import axios from 'axios'
import { HsPart, HsTreeResponseDto } from '@/modules/hs/types/hs-response'

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_HOST_PORT || 'http://localhost:4444/api',
  timeout: 10000,
})

const baseURL =
  process.env.NEXT_PUBLIC_API_HOST_PORT || 'http://localhost:4444/api'

export const hsCodeApi = {
  getChapter: (): Promise<HsPart[]> =>
    api.get<HsPart[]>(`/hscode/chapter`).then((response) => response.data),

  search: (params: { q?: string; chapterIds?: string; taxTypes?: string }): Promise<HsTreeResponseDto[]> => {
    const p = new URLSearchParams()
    if (params.q) p.set('q', params.q)
    if (params.chapterIds) p.set('chapterIds', params.chapterIds)
    if (params.taxTypes) p.set('taxTypes', params.taxTypes)
    return api.get(`/hscode/search?${p.toString()}`).then((r) => r.data)
  },

  getHsByCode: (id: string): Promise<HsTreeResponseDto[]> =>
    api.get(`/hscode/search-by-code/${id}`).then((response) => response.data),

  getSitemapCodes: (chapterId?: number): Promise<{ hsCode: string; updatedAt: string }[]> =>
    api
      .get(`/hscode/sitemap-codes${chapterId !== undefined ? `?chapterId=${chapterId}` : ''}`)
      .then((response) => response.data),
}

export async function getHsSearch(params: { q?: string; chapterIds?: string; taxTypes?: string }): Promise<HsTreeResponseDto[]> {
  const p = new URLSearchParams()
  if (params.q) p.set('q', params.q)
  if (params.chapterIds) p.set('chapterIds', params.chapterIds)
  if (params.taxTypes) p.set('taxTypes', params.taxTypes)

  const response = await fetch(`${baseURL}/hscode/search?${p.toString()}`)

  if (!response.ok) {
    throw new Error('Failed to fetch HS search results')
  }

  return response.json()
}


export async function getHsDetailByCode(hsCode: string): Promise<any> {
  const response = await fetch(`${baseURL}/hscode/${hsCode}`, {
    cache: 'force-cache', // Explicitly enable caching
    next: {
      revalidate: 86400, // Revalidate after 24 hours
      tags: ['hs-detail', `hs-${hsCode}`], // For on-demand revalidation
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch HS detail for code: ${hsCode}`)
  }

  return response.json()
}
